module.exports = __webpack_public_path__ + "img/icon_map_js_c.a5864107.png";